"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavStateProvider = exports.NavStateContext = exports.NavState = void 0;
var react_1 = __importStar(require("react"));
var NavState;
(function (NavState) {
    NavState[NavState["NOT_COLLAPSED"] = 0] = "NOT_COLLAPSED";
    NavState[NavState["COLLAPSED"] = 1] = "COLLAPSED";
})(NavState = exports.NavState || (exports.NavState = {}));
exports.NavStateContext = react_1.default.createContext({
    state: NavState.NOT_COLLAPSED,
    saveState: function () { }
});
exports.NavStateProvider = function (_a) {
    var children = _a.children;
    var _b = react_1.useState(NavState.NOT_COLLAPSED), navState = _b[0], setNavState = _b[1];
    var saveState = function (value) {
        setNavState(value);
    };
    return (react_1.default.createElement(exports.NavStateContext.Provider, { value: { state: navState, saveState: saveState } }, children));
};
